import { CombinedLogs } from '@/modules/CombinedLogs'
import { Mileage } from '@/modules/Mileage'
import { FindControllerLog } from '@/modules/FindControllerLog'
import { useReaderLogStore } from '@/modules/FindControllerLog/store'
import { DateInput } from '@/components/DateInput'
import { Routes } from '@/modules/Workstation/ui/components/Routes'

import commonStyles from './Dashboard.module.scss'
import styles from './ReaderDashboard.module.scss'

export const ReaderDashboard = () => {
    const { source } = useReaderLogStore()

    if (!source) {
        return <FindControllerLog />
    }

    return (
        <section className={commonStyles.root}>
            <div className={commonStyles.header}>
                <div className={styles.sourceContainer}>
                    <div className={styles.sourceHeader}>
                        <h4 className={styles.sourceTitle}>{source.title}</h4>
                        <DateInput />
                    </div>
                    <Routes isReadOnly isEditable={false} />
                </div>
                <Mileage displayed />
            </div>

            <CombinedLogs />
        </section>
    )
}
